import React, { useState } from 'react';
import s from './s.module.less';
import { EAiRole, TAiMessage, TAIUploadImage } from 'types/ai';
import Avatar from './imgs/avatar.png';
import Spark from './imgs/sparkles.svg';
import dayjs from 'utils/dayjs';
import MarkdownRenderer from 'components/MarkdownRenderer';

type Props = {
    showIcon?: boolean;
    showTime?: boolean;
    item: TAiMessage,
    onClickQuestion: (question: string) => void;
    onClickImage?: (url: string) => void;
};

export default function MessageItem({ showIcon, showTime, item, onClickQuestion, onClickImage }: Props) {
    const hasFile = item.blobs && item.blobs.length > 0;
    const hasLoaderImage = item.files && item.files.length > 0;
    const showImage = hasFile || hasLoaderImage;
    if (item.role === EAiRole.QUESTION) {
        const questions = item.content.split('---');
        return (
            <div className={s.aiWrap}>
                {
                    showIcon && (
                        <div className={s.avatarWrap}>
                            <img src={Avatar} alt="avatar" />
                        </div>
                    )
                }
                <div className={s.questionsWrap}>
                    {
                        questions?.map((question) => {
                            return (
                                <div key={question}>
                                    <div className={s.questionItem} key={question} onClick={() => onClickQuestion?.(question)}>
                                        {/* <img src={Spark} alt="spark" className={s.sp} /> */}
                                        {question}
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }

    if (item.role === EAiRole.USER) {
        return (
            <div className={s.userWrap}>
                {showTime &&
                    <div className={s.time}>
                        {dayjs(item.timestamp).format('hh:mm A')}
                    </div>
                }
                {
                    hasFile && (
                        <div className={s.imageWrap}>
                            {
                                item.blobs?.map((file: TAIUploadImage) => {
                                    // let url: string = '';
                                    // try {
                                    //     url = URL.createObjectURL(file);
                                    // } catch (e: any) {
                                    //     console.error(e);
                                    //     return null;
                                    // }
                                    return (
                                        <div className={s.imageItem} key={file.url}>
                                            <img
                                                onClick={() => {
                                                    onClickImage?.(file.url);
                                                }}
                                                src={file.url}
                                                alt="screenshot"
                                            />
                                        </div>
                                    );
                                })
                            }
                        </div>
                    )
                }
                {
                    !hasFile && hasLoaderImage && (
                        <div className={s.imageWrap}>
                            {
                                item.files?.map((image) => {
                                    return (
                                        <div className={s.imageItem} key={image.url}>
                                            <img
                                                onClick={() => {
                                                    onClickImage?.(image.url);
                                                }}
                                                src={image.url}
                                                alt="screenshot"
                                            />
                                        </div>
                                    );
                                })
                            }
                        </div>
                    )
                }

                <div className={s.content}>
                    <MarkdownRenderer size="small" content={item.content || ''} />
                </div>
            </div>
        );
    }

    return (
        <div className={s.aiWrap}>
            {
                showIcon && (
                    <div className={s.avatarWrap}>
                        <img src={Avatar} alt="avatar" />
                    </div>
                )
            }
            <div className={s.content}>
                <MarkdownRenderer size="small" content={item.content || ''} />
            </div>
        </div>
    );
}
